import React, { useEffect, useState, useCallback } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import loginSchema from "../validation/loginSchema";
import { useDispatch, useSelector } from "react-redux";
import { authActions, myAccountActions } from "../_store";
import { encryptData } from "../utils/encryptDecrypt";
import LoginImg from "../../src/assets/images/banner-img-new.jpg";
import Logo from "../assets/dr_inmate_logo.png";
import useFullPageLoader from "../hooks/useFullPageLoader";
import NotificationService from "../ui/ui-modal-notification.js";
import {
  base64DecryptData,
  decryptDataInviteLink,
} from "../utils/encryptDecrypt";
import { ReactNotifications } from "react-notifications-component";
import PopupComponent from "../components/PopupComponent/ConnectionPopup.jsx";
import AndroidPopupComponent from "../components/PopupComponent/MobileAppAlertAndroidPopup.jsx";
import ApplePopupComponent from "../components/PopupComponent/MobileAppAlertApplePopup.jsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ConfirmationModal from "../components/common/UI/Inputs/NotificationModal/BootstrapModalPopup";
import {
  faEye,
  faEyeSlash,
  faSpinner,
} from "@fortawesome/free-solid-svg-icons";
import { EventLog } from "../components/common/EventLog/EventLog.jsx";
import { storeCurrentRoute } from "../utils/routeTracker.js";
import Marquee from "react-fast-marquee";
import useIPAddress from "../hooks/useIPAddress.jsx";
import useBrowserType from "../hooks/useBrowserType.jsx";
import { getStoredValue, removeStoredValue, setStoredValue } from "../_helpers/storagehelper.js";

function Login() {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const ip = useIPAddress();
  const browser = useBrowserType();
  const authUser = useSelector((state) => state);
  const [showPassword, setShowPassword] = useState(false);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [buttonLoading, setButtonLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenAndroid, setIsModalOpenAndroid] = useState(false);
  const [isModalOpenApple, setIsModalOpenApple] = useState(false);
  const [isInviteLinkModal, setIsInviteLinkModal] = useState(false);
  const [maintenanceScheduleText, setMaintenanceScheduleText] = useState("");
  const [isMaintenance, setIsMaintenance] = useState(false);
  const { registerEmailActivateResponse, error } = useSelector(
    (state) => state.auth
  );

  const { username, password } = location.state || {};
  //  const { emailSaveResponse } = useSelector((state) => state.validateUserEmail);
  const { emailSaveResponse, LoadApplicationMaintenceResponse } = useSelector(
    (state) => state.auth
  );
  const [isReactivateAccount, setIsReactivateAccount] = useState(false);
  const [loginForm, setLoginForm] = useState({
    UserName: "",
    UserPassword: "",
    BrowserType: "",
    IPAddress: "192.168.25.10",
  });

  const { token } = useSelector((state) => state.auth);
  const from = location.state?.from?.pathname || "/public/Inbox";

  const [inmateKioskInvite, setInmateKioskInvite] = useState({
    PublicUserID: 0,
    InmateID: 0,
    InviteGUID: "",
    InmateInvitePublicUserID: 0,
    InmateFullName: "",
    PUIConnectionID: 0,
    ConnectionStatusID: 0,
    RelationshipStatus: "",
    InmateStatus: 0,
    FacilityID: 0,
    StateNameID: 0,
    InmateResidentId: 0,
    ContactNumberOrEmail: "",
    InviteThrough: "",
    FirstName: "",
    LastName: "",
    InviteLink: "",
  });

  const [errorMessage, setErrorMessage] = useState({});

  //added for event log
  let infoMessage = "";
  let redirectURL = "";
  let Status = "";
  let Response = "---";

  useEffect(() => {
    let isloginpermit = sessionStorage.getItem("from");
    if (username && password && isloginpermit === "admin") {
      // Trigger reactivation popup when username and password are passed
      setIsReactivateAccount(true);
      setLoginForm((prevForm) => ({
        ...prevForm,
        UserName: username,
        UserPassword: password,
      }));
    }
  }, [username, password]);

  // Dev tools disable and enable option based on env variable (temporary)
  useEffect(() => {
    dispatch(authActions.InspectElementBlock())
      .then((response) => {
        if (response?.payload === 1) {
          const script = document.createElement("script");
          script.src = "https://cdn.jsdelivr.net/npm/disable-devtool";
          script.setAttribute("disable-devtool-auto", "");
          document.body.appendChild(script);

          // Cleanup function
          return () => {
            document.body.removeChild(script);
          };
        }
      })
      .catch((error) => console.error("Error blocking dev tools:", error));
  }, [dispatch]);


  const [showModal, setShowModal] = useState(false);

  const [modalContent, setModalContent] = useState({
    title: "",
    messageHTML: "",
    message: "",
    showCancelButton: true,
    onConfirm: () => { },
    onCancel: () => { },
  });


  // Function used for If token is not null or undefined means not allow to show login page
  useEffect(() => {
    if (token && authUser?.auth?.user !== null) {
      navigate(from, { replace: true }); // Redirect to the original page or '/dashboard'
    }
  }, [token, navigate, from]);

  // Get Admin set Cookies - (Admin login as a Public User Functionality)
  function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(";").shift();
  }

  // Remove admin set Cookie - (Admin login as a Public User Functionality)
  // const removeAllCookies = async() => {
  //   const cookies = document.cookie.split(";");

  //   await cookies.forEach((cookie) => {
  //     const cookieName = cookie.split("=")[0].trim();
  //     document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  //   });
  // };

  const removeAllCookies = async () => {
    const cookies = document.cookie.split(";");

    // Loop through each cookie and clear it
    cookies.forEach((cookie) => {
      const cookieName = cookie.split("=")[0].trim();
      // Ensure you set the correct path and domain when removing cookies
      document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${process.env.REACT_APP_PUBLIC_USER_DOMAIN}; secure; SameSite=None;`;
    });
  };


  useEffect(() => {
    let isMounted = true;

    const fetchData = async () => {
      const ipAddress = ip;
      const browserType = browser;

      // Grouping the state updates to avoid conflicts
      if (isMounted) {
        setLoginForm((prevForm) => ({
          ...prevForm,
          IPAddress: ipAddress,
          BrowserType: browserType,
        }));
      }
    };

    fetchData();

    return () => {
      isMounted = false; // cleanup on unmount
    };
  }, [ip, browser]); // Add dependencies for  getBrowserType

  // Get login response and if success means navigate into dashboard


  const onSignupClick = () => {
    setIsModalOpen(false);
    navigate(
      "/public/Register?InviteLink=" +
      encodeURIComponent(inmateKioskInvite.InviteLink)
    );
    storeCurrentRoute("/public/Register?InviteLink=" +
      encodeURIComponent(inmateKioskInvite.InviteLink));
  };

  const onLoginClick = () => {
    setLoginForm((prevForm) => ({
      ...prevForm, UserName: inmateKioskInvite.ContactNumberOrEmail
    }));
    setIsModalOpen(false);
    navigate(
      "/public/Login?InviteLink=" +
      encodeURIComponent(inmateKioskInvite.InviteLink) +
      "&IsRedirectedInvitedURL=true"
    );
    storeCurrentRoute("/public/Login?InviteLink=" +
      encodeURIComponent(inmateKioskInvite.InviteLink) +
      "&IsRedirectedInvitedURL=true");
  };

  const onMobileLoginClick = (e) => {
    setIsModalOpenApple(false);
    setIsModalOpenAndroid(false);
    handleLogin(e);
  };

  const handleMobileAppAlert = () => {
    let Ismobile = false;
    const ua = navigator.userAgent.toLowerCase();
    const isAndroid = ua.includes("android");
    const isIPhone = ua.includes("iphone");
    // Reset alerts
    setIsModalOpenAndroid(false);
    setIsModalOpenApple(false);

    if (isAndroid) {
      Ismobile = true;
      setIsModalOpenAndroid(true);
    } else if (isIPhone) {
      Ismobile = true;
      setIsModalOpenApple(true);
    }
    return Ismobile;
  };

  // Load Application Maintence
  useEffect(() => {
    dispatch(authActions.LoadApplicationMaintence())
  }, [dispatch]);

  // Application Maintence Response
  useEffect(() => {
    if (LoadApplicationMaintenceResponse) {
      if (LoadApplicationMaintenceResponse.length > 0) {
        setIsMaintenance(true);
        setMaintenanceScheduleText(
          LoadApplicationMaintenceResponse[0].MaintanenceAlert
        );
      } else {
        setIsMaintenance(false);
      }
    } else {
      setIsMaintenance(false);
    }
  }, [LoadApplicationMaintenceResponse]);

  // Used for if user click activation link means call API for check activation status
  useEffect(() => {
    // Extract query parameters
    const searchParams = new URLSearchParams(location.search);
    const userID = searchParams.get("UserID");
    const inviteLink = searchParams.get("InviteLink");
    const isRegisterAsMobile = searchParams.get("IsRegisterAsMobile");
    const isRedirectedInvitedURL = searchParams.get("IsRedirectedInvitedURL");
    const token = searchParams.get("token");
    const redirectTo = searchParams.get("redirectTo");
    const iframeUserID = searchParams.get("iframeUserID");
    const UserName = searchParams.get("UserName");
    const UserPassword = searchParams.get("UserPassword");
    const PUPasswordLogID = searchParams.get("PUPasswordLogID");
    if ([...searchParams.keys()].length > 0) {
      if (inviteLink && inviteLink.trim() !== "") {
        // If IsRegisterAsMobile, UserId, or IsRedirectedInvitedURL are not present
        if (!isRegisterAsMobile && !userID && !isRedirectedInvitedURL) {
          try {
            // Decrypt the invite link

            const decodedInviteLink = decryptDataInviteLink(
              decodeURIComponent(inviteLink)
            );
            if (decodedInviteLink !== "") {
              // Split the decrypted link (assuming it's separated by '&')
              const inviteLinkInfo = decodedInviteLink.split("&");

              // Assuming the first part is InmateID and the second part is InviteGUID
              const inmateID = inviteLinkInfo[0];
              const inviteGUID = inviteLinkInfo[1];

              // Perform the action with the decoded data
              dispatch(
                authActions.InviteLink({
                  InmateID: parseInt(inmateID), // Using decoded InmateID
                  InviteGUID: inviteGUID, // Using decoded InviteGUID
                  PublicUserId: 0, // Set default as per original C# logic
                })
              )
                .then((response) => {
                  // Assuming response contains inmate details
                  if (response.payload !== null) {
                    setStoredValue("IsInvitedURL", true);
                    setInmateKioskInvite((prevState) => ({
                      ...prevState,
                      ...response.payload,
                      InviteLink: inviteLink,
                      IsRegisteredFromInvite:
                        response.payload?.InviteThrough == "Mobile"
                          ? 1
                          : response.payload?.InviteThrough == "Email"
                            ? 2
                            : 0,
                    }));
                    setIsModalOpen(true);
                    setIsInviteLinkModal(false);
                  } else {
                    setStoredValue("IsInvitedURL", false);
                    setIsModalOpen(false);
                    setIsInviteLinkModal(true);
                  }
                })
                .catch((error) => {
                  setIsModalOpen(false);
                });
            } else {
              setIsInviteLinkModal(true);
            }
          } catch (error) {
            setIsModalOpen(false);
          }
        }
      } else if (iframeUserID && token) {
        dispatch(authActions.setToken(token));
        sessionStorage.setItem("from", "admin");
        setStoredValue("isloginpermit", true, true);
        setStoredValue("token", token);
        setStoredValue("userID", iframeUserID);
        setStoredValue("UserName", UserName, true);
        setStoredValue("UserPassword", UserPassword, true);
        setStoredValue("PUPasswordLogID", PUPasswordLogID);
        const publicUserId = getStoredValue("userID");
        localStorage?.setItem(`isAuthenticated_${publicUserId?.toString()}`, true);
        if (redirectTo !== undefined && redirectTo == 1) {
          navigate("/public/FindInmates");
          storeCurrentRoute("/public/FindInmates");
        } else if (redirectTo !== undefined && redirectTo == 3) {
          navigate("/public/Inbox");
          storeCurrentRoute("/public/Inbox");
        } else {
          navigate("/public/WriteMessage");
          storeCurrentRoute("/public/WriteMessage");
        }
      } else {
        setStoredValue("UserPassword", null);
        setStoredValue("IsInvitedURL", false);
      }
      UserActivation();
    }
  }, [location]);



  const UserActivation = () => {
    const fullURL = window.location.href;
    // Extract query parameters
    const searchParams = new URLSearchParams(location.search);
    const userID = searchParams.get("UserID");
    const For = searchParams.get("For");
    const UbTo = searchParams.get("UbTo");

    // Show success message if UserID is 'MA=='
    if (userID !== undefined && userID !== null) {
      const user = base64DecryptData(userID);
      showLoader();
      dispatch(
        authActions.PublicUserLoginActivationStatus({
          url: encodeURIComponent(fullURL),
          userType: "PublicUser",
          publicUserEmail: "''",
          userID: user,
        })
      ).then((response) => {
        hideLoader();
      });
    } else if (For !== undefined && For !== null) {
      const user = base64DecryptData(For);
      showLoader();
      dispatch(
        authActions.PublicUserUnsubscribeMail({
          userID: user,
        })
      ).then((response) => {
        hideLoader();
        setTimeout(() => {
          navigate("/public/Login");
          storeCurrentRoute("/public/Login");
        }, 3000);
        if (response.payload === 1) {
          NotificationService({
            title: "Message",
            message:
              "You’ve been successfully unsubscribed from all Inmate e-mail notifications.To re-subscribe click on the same link from your mail.",
            type: "success", // can be 'success', 'danger', 'info', 'warning'
          });
        } else if (response.payload === 2) {
          NotificationService({
            title: "Message",
            message:
              "You’ve been successfully subscribed from all Inmate e-mail notifications.To unsubscribe click on the same link from your mail.",
            type: "success", // can be 'success', 'danger', 'info', 'warning'
          });
        } else if (response.payload === -1) {
          NotificationService({
            title: "Message",
            message: "Operation failed",
            type: "warning", // can be 'success', 'danger', 'info', 'warning'
          });
        } else if (response.payload === -2) {
          NotificationService({
            title: "Message",
            message: "Not a valid user",
            type: "warning", // can be 'success', 'danger', 'info', 'warning'
          });
        }
      });
    } else if (UbTo !== undefined && UbTo !== null) {
      const email = base64DecryptData(UbTo);
      showLoader();
      dispatch(
        authActions.UsPublicSubscribeUnsubscribeMail({
          email: email,
        })
      ).then((response) => {
        hideLoader();
        setTimeout(() => {
          navigate("/public/Login");
          storeCurrentRoute("/public/Login");
        }, 3000);
        if (response.payload === 1 || response.payload === 3) {
          NotificationService({
            title: "Message",
            message:
              "You’ve been successfully unsubscribed from all Inmate e-mail notifications.To re-subscribe click on the same link from your mail.",
            type: "success", // can be 'success', 'danger', 'info', 'warning'
          });
        } else if (response.payload === 2) {
          NotificationService({
            title: "Message",
            message:
              "You’ve been successfully subscribed from all Inmate e-mail notifications.To unsubscribe click on the same link from your mail.",
            type: "success", // can be 'success', 'danger', 'info', 'warning'
          });
        } else if (response.payload === -1) {
          NotificationService({
            title: "Message",
            message: "Operation failed",
            type: "warning", // can be 'success', 'danger', 'info', 'warning'
          });
        } else if (response.payload === -2) {
          NotificationService({
            title: "Message",
            message: "Not a valid user",
            type: "warning", // can be 'success', 'danger', 'info', 'warning'
          });
        } else if (response.payload === -3) {
          NotificationService({
            title: "Message",
            message: "Already Unsubscribed",
            type: "warning", // can be 'success', 'danger', 'info', 'warning'
          });
        } else if (response.payload === -2) {
          NotificationService({
            title: "Message",
            message: "Not a Valid E-mail",
            type: "warning", // can be 'success', 'danger', 'info', 'warning'
          });
        }
      });
    }
  };

  // First time user register after show the activation status here.
  useEffect(() => {
    setButtonLoading(false);

    if (
      registerEmailActivateResponse !== undefined &&
      registerEmailActivateResponse === 1
    ) {
      NotificationService({
        title: "Success",
        message: "Account successfully activated. You can now log in!.",
        type: "success", // can be 'success', 'danger', 'info', 'warning'
      });
      dispatch(authActions.clearRegisterEmailActivateResponse());
    } else if (
      registerEmailActivateResponse !== undefined &&
      registerEmailActivateResponse === 0
    ) {
      NotificationService({
        title: "Warning",
        message: "Incorrect URL !!!",
        type: "warning", // can be 'success', 'danger', 'info', 'warning'
      });
      dispatch(authActions.clearRegisterEmailActivateResponse());
    } else if (
      registerEmailActivateResponse !== undefined &&
      registerEmailActivateResponse === -2
    ) {
      NotificationService({
        title: "Warning",
        message:
          "The account verification link has expired. Please use the link received in your recently updated e-mail.",
        type: "warning", // can be 'success', 'danger', 'info', 'warning'
      });
      dispatch(authActions.clearRegisterEmailActivateResponse());
    } else if (
      registerEmailActivateResponse !== undefined &&
      registerEmailActivateResponse === -3
    ) {
      NotificationService({
        title: "Warning",
        message:
          "The account activation link has expired. Please use the recent activation link received in your e-mail.",
        type: "warning", // can be 'success', 'danger', 'info', 'warning'
      });
      dispatch(authActions.clearRegisterEmailActivateResponse());
    } else if (
      registerEmailActivateResponse !== undefined &&
      registerEmailActivateResponse === -4
    ) {
      NotificationService({
        title: "Warning",
        message: "Your account is already activated.",
        type: "warning", // can be 'success', 'danger', 'info', 'warning'
      });
      dispatch(authActions.clearRegisterEmailActivateResponse());
    } else if (
      registerEmailActivateResponse !== undefined &&
      registerEmailActivateResponse === 2
    ) {
      NotificationService({
        title: "Success",
        message:
          "E-mail verified successfully. Please login below with your credentials.",
        type: "success", // can be 'success', 'danger', 'info', 'warning'
      });
      dispatch(authActions.clearRegisterEmailActivateResponse());
    } else if (
      registerEmailActivateResponse !== undefined &&
      registerEmailActivateResponse === 3
    ) {
      NotificationService({
        title: "Success",
        message:
          "Activation success. Please login with your mobile app or below with your credentials.",
        type: "success", // can be 'success', 'danger', 'info', 'warning'
      });
      dispatch(authActions.clearRegisterEmailActivateResponse());
    } else if (
      registerEmailActivateResponse !== undefined &&
      registerEmailActivateResponse === -1
    ) {
      NotificationService({
        title: "Failed",
        message: "User activation failed.",
        type: "danger", // can be 'success', 'danger', 'info', 'warning'
      });
      dispatch(authActions.clearRegisterEmailActivateResponse());
    } else if (
      emailSaveResponse.ForgetTypeResult === 2 &&
      emailSaveResponse.IsValidUser === 1
    ) {
      NotificationService({
        title: "Success",
        message: "Username sent to your registered e-mail",
        type: "success", // can be 'success', 'danger', 'info', 'warning'
      });
      dispatch(authActions.clearEmailSaveResponse());
    } else if (
      emailSaveResponse.ForgetTypeResult === 1 &&
      emailSaveResponse.IsValidUser === 1
    ) {
      NotificationService({
        title: "Success",
        message: "Reset password link sent successfully",
        type: "success", // can be 'success', 'danger', 'info', 'warning'
      });
      dispatch(authActions.clearEmailSaveResponse());
    }
  }, [registerEmailActivateResponse, error]);

  // Validate a specific field in the form data
  const validateForm = (formData, fieldName = null) => {
    setErrorMessage({});

    // Remove error class from inputs
    document.querySelectorAll(".input-error").forEach((element) => {
      element.classList.remove("input-error");
    });

    // Validate the whole form if no specific field is provided
    const { error } = loginSchema(formData);
    if (error?.details) {
      error.details.forEach((err) => {
        const { path } = err;

        // Check if the error is for the specific field
        if (!fieldName || path[0] === fieldName) {
          setErrorMessage((prev) => ({
            ...prev,
            [path[0]]: err.message,
          }));

          // Add error class to input
          document
            .querySelector(`input[name=${path[0]}]`)
            ?.classList?.add("input-error");
        }
      });
      return false;
    }
    return true;
  };

  // Updated handleChange function
  const handleChange = (e) => {
    const { name, value } = e.target;

    setLoginForm((prevForm) => ({
      ...prevForm,
      [name]: value.trim(),
    }));

    validateForm({ [name]: value.trim() }, name); // Validate specific field
  };

  // Close modal popup Invite Link
  const handlecancelInvite = () => {
    setIsInviteLinkModal(false);
  };

  const handleReactivate = async () => {
    try {
      if (loginForm.UserName && loginForm.UserPassword) {
        const response = await dispatch(
          myAccountActions.PublicUserReactivatelMyAccount(loginForm)
        ).unwrap();
        // Check response and handle accordingly
        if (response === 1) {
          setIsReactivateAccount(false); // Close modal
          const encryptPassword = encryptData(loginForm?.UserPassword);
          const browserType = browser;
          const IpAddress = ip;
          const updatedLoginForm = {
            ...loginForm,
            UserPassword: encryptPassword,
            BrowserType: browserType,
            IPAddress: IpAddress,
          };
          setButtonLoading(true);
          await dispatch(authActions.login(updatedLoginForm)).then((x) => {
            handleloginResponse(x?.payload)
          });
          hideLoader();
        }
      }
    } catch (error) {
      console.error("Error during reactivation:", error);
    }
  };

  const handlecancel = () => {
    setIsReactivateAccount(false);
  };

  // Login submit function
  const handleLogin = async () => {
    setStoredValue("isloginpermit", true, true);
    if (!validateForm(loginForm)) {
      // Stop if there are validation errors
      return;
    }
    const encryptPassword = encryptData(loginForm?.UserPassword);
    const updatedLoginForm = { ...loginForm, UserPassword: encryptPassword };
    setButtonLoading(true);
    await dispatch(authActions.login(updatedLoginForm)).then((x) => {
      handleloginResponse(x?.payload)
    });
    hideLoader();
  };


  const handleloginResponse = (userdata) => {
    hideLoader();
    if (userdata) {
      let user = userdata;
      if (user !== null) {
        if (user.IsLoginValid === 1) {
          const searchParams = new URLSearchParams(location.search);
          const inviteLink = searchParams.get("InviteLink");
          dispatch(authActions.clearEmailResponse());
          removeStoredValue("user");
          let URL = "/public/FindInmates";
          if (
            getStoredValue("IsInvitedURL") &&
            [...searchParams.keys()].length > 0 &&
            inviteLink !== null
          ) {
            navigate(
              "/public/FindInmates?InviteLink=" + encodeURIComponent(inviteLink)
            );
            storeCurrentRoute("/public/FindInmates?InviteLink=" + encodeURIComponent(inviteLink));
          } else if (user.RedirectTo !== undefined && user.RedirectTo === 1) {
            navigate("/public/FindInmates");
            storeCurrentRoute("/public/FindInmates?InviteLink=" + encodeURIComponent(inviteLink));
          } else if (user.RedirectTo !== undefined && user.RedirectTo === 3) {
            navigate("/public/Inbox");
            URL = "/public/Inbox";
          } else {
            navigate("/public/WriteMessage");
            URL = "/public/WriteMessage";
          }
          storeCurrentRoute(URL);

          //added for event log
          infoMessage = "Public User clicked into the login button";
          redirectURL = URL;
          Status = "Login Success";
          // EventLog(dispatch, infoMessage, redirectURL, Status);
        } else if (user.IsLoginValid === -4 && user.UserActivateDate == null) {
          setModalContent({
            title: "Account Activation Required",
            messageHTML:
              "This account is not activated yet. Kindly, <strong>activate your account</strong> by clicking on the activation link received in your registered e-mail.",
            message: "",
            showCancelButton: false,
            onConfirm: () => setShowModal(false),
          });
          Status =
            "This account is not activated yet. Kindly, activate your account by clicking on the activation link received in your registered e-mail.";
          setShowModal(true);
        } else if (user.IsLoginValid === -4 && user.UserActivateDate != null) {
          setModalContent({
            title: "Account Activation Required",
            messageHTML:
              "This account is not reactivated yet. Kindly, <strong>verify your e-mail</strong> by clicking on the verification link received in your updated e-mail.",
            message: "",
            showCancelButton: false,
            onConfirm: () => setShowModal(false),
          });
          Status =
            "This account is not reactivated yet. Kindly, verify your e-mail by clicking on the verification link received in your updated e-mail.";
          setShowModal(true);
        } else if (user.IsLoginValid === -1) {
          setModalContent({
            title: "Operation Failed",
            messageHTML: "",
            message: "Operation Failed.",
            showCancelButton: false,
            onConfirm: () => setShowModal(false),
          });
          setShowModal(true);
          Status = "Error in save. Please try again.";
        } else if (user.IsLoginValid === -2) {
          setModalContent({
            title: "Invalid Credentials!",
            messageHTML: "",
            message: "Invalid Credentials!",
            showCancelButton: false,
            onConfirm: () => setShowModal(false),
          });
          Status = "Password is invalid. Please try again.";
          setShowModal(true);
          setLoginForm((prevForm) => ({
            ...prevForm,
            UserPassword: "",
            UserName: "",
          }));
        } else if (user.IsLoginValid === -3) {
          setModalContent({
            title: "User Blocked",
            messageHTML:
              "Your Account is temporarily Blocked by Administrator.",
            message: "",
            showCancelButton: false,
            onConfirm: () => setShowModal(false),
          });
          Status = "Your Account is temporarily Blocked by Administrator.";
          setShowModal(true);
        } else if (user.IsLoginValid === -5) {
          setModalContent({
            title: "Invalid User",
            messageHTML: "",
            message: "User is invalid. Please try again.",
            showCancelButton: false,
            onConfirm: () => setShowModal(false),
          });
          Status = "User is invalid. Please try again.";
          setShowModal(true);
          setLoginForm((prevForm) => ({
            ...prevForm,
            UserPassword: "",
            UserName: "",
          }));
        } else if (user.IsLoginValid === -6) {
          setIsReactivateAccount(true);
          removeStoredValue("user");
          Status =
            "Your account is temporarily deactivated, you can reactivate your account now. Please click YES to activate and login to your account.";
        }
        dispatch(authActions.clearEmailResponse());
      }
      EventLog(dispatch, infoMessage, redirectURL, Response, Status);
    }
  }

  return (
    <div id="app" className="app">
      <ConfirmationModal
        show={showModal}
        onHide={() => setShowModal(false)}
        onConfirm={modalContent.onConfirm}
        title={modalContent.title}
        messageHTML={modalContent.messageHTML}
        message={modalContent.message}
        showCancelButton={modalContent.showCancelButton}
        onconfirmname="OK" // Only "OK" button
        oncancelname=""
        size="md p-4" // Set modal size to medium
        closeButton={false} // Optional: hide close button
      />

      <ReactNotifications />
      <div className="login login-with-news-feed">
        <div className="news-feed">
          <div
            className="news-image"
            style={{
              backgroundImage: `url(${LoginImg})`,
            }}
          ></div>
          <div className="news-caption">
            <h1 className="text-white font-xl">
              <b>INMATE INBOX</b>
            </h1>
            <p className="font-size-20 max-width-80">
              Send & Receive Secure Electronic Messages With Your{" "}
              <span className="default-color">Loved</span> Ones. There’s no
              better way to stay connected with your loved one or friend than
              real time messages.
            </p>
          </div>
        </div>

        <div className="login-container">
          {isMaintenance && (
            <div style={{}}>
              {/* <marquee
                className="notification-batch-home"
                direction="left"
                style={{
                  color: "#cf5c5c",
                }}
              >
                {maintenanceScheduleText}
              </marquee> */}
              <Marquee
                gradient={false}
                speed={30}
                pauseOnHover={true}
                style={{ color: "#cf5c5c", backgroundColor: "#fee", fontSize: '15px', marginBottom: "1rem" }}
              >
                {maintenanceScheduleText + "                         "}
              </Marquee>
            </div>
          )}

          <div className="login-header mb-20px">
            <div className="brand">
              <div
                className="d-flex align-items-center"
                style={{ justifyContent: "center" }}
              >
                <img src={Logo} className="login-logo" alt=""></img>
              </div>
            </div>
          </div>
          <div className="login-content">
            <form className="fs-13px">
              <div className="form-floating mb-15px">
                <input
                  type="text"
                  className="form-control h-45px fs-13px"
                  placeholder="E-mail"
                  id="emailAddress"
                  name="UserName"
                  value={loginForm.UserName}
                  // onCopy={(e) => e.preventDefault()}
                  // onCut={(e) => e.preventDefault()}
                  // onPaste={(e) => e.preventDefault()}
                  maxLength="64"
                  autoComplete="new-username"
                  onChange={(e) => handleChange(e)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      handleLogin();
                    }
                  }}
                />
                <label
                  htmlFor="emailAddress"
                  className="d-flex align-items-center fs-13px text-gray-600"
                >
                  Username / E-mail
                  <span className="text-danger ps-1">
                    <strong>*</strong>
                  </span>
                </label>
              </div>
              <div className="text-danger fw-700 fs-6 mb-20px mt-1">
                {errorMessage["UserName"] && errorMessage["UserName"]}
              </div>
              <div className="form-floating mb-15px position-relative">
                <input
                  type={showPassword ? "text" : "password"} // Conditional type based on toggle state
                  name="UserPassword"
                  className="form-control h-45px fs-13px"
                  placeholder="Password"
                  onChange={handleChange}
                  value={loginForm.UserPassword}
                  // onCopy={(e) => e.preventDefault()}
                  // onCut={(e) => e.preventDefault()}
                  // onPaste={(e) => e.preventDefault()}
                  maxlength="50"
                  autoComplete="new-password"
                  id="password"
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      handleLogin();
                    }
                  }}
                />
                <label
                  htmlFor="password"
                  className="d-flex align-items-center fs-13px text-gray-600"
                >
                  Password
                  <span className="text-danger ps-1">
                    <strong>*</strong>
                  </span>
                </label>
                <span
                  className="position-absolute end-0 top-0 mt-4 me-3 cursor-pointer"
                  onClick={() => setShowPassword(!showPassword)} // Toggle visibility
                >
                  <FontAwesomeIcon icon={showPassword ? faEye : faEyeSlash} />
                </span>
              </div>
              <div className="text-danger fw-700 fs-6 mb-20px mt-1">
                {errorMessage["UserPassword"] && errorMessage["UserPassword"]}
              </div>
              <div className="mb-15px">
                <button
                  type="button"
                  onClick={() => {
                    if (!handleMobileAppAlert()) {
                      handleLogin();
                    }
                  }}
                  className="btn btn-theme d-block w-100 btn-lg h-45px fs-15px"
                  disabled={buttonLoading}
                >
                  {buttonLoading ? (
                    <>
                      <FontAwesomeIcon icon={faSpinner} spin className="me-2" />
                      Signing in...
                    </>
                  ) : (
                    "Sign in"
                  )}
                </button>
                {/* <button
                  type="submit"
                  className="btn btn-success me-2  font-size-14 mb-2"
                  onClick={() => removeAllCookies()}
                >
                 
                  Cookies
                </button> */}
              </div>
              <div class="forget-password-list font-size-15">
                {/* <p><a href="#" class="font-size-14">
                  Forgot Username / Password? </a> <span class="m-lg-2"> |  </span><a href="#" class="font-size-14 margin-5">Resend Activation Mail </a></p> */}
                {/* <Link to="/public/ForgotPassword">
                  {" "} */}
                <Link
                  to="/public/ForgotPassword"
                  onClick={() => {
                    infoMessage =
                      "Public User clicked into the Forget Username / Password link button";
                    redirectURL = "/public/ForgotPassword";
                    Status = "Redirected into Forget Password / Username Panel";
                    Response = "/public/ForgotPassword";

                    EventLog(
                      dispatch,
                      infoMessage,
                      redirectURL,
                      Response,
                      Status,
                    );
                  }}
                >
                  Forgot Username / Password?
                </Link>{" "}
                |{/* <Link to="/public/SendActivateMail"> */}
                <Link
                  to="/public/SendActivateMail"
                  onClick={() => {
                    infoMessage =
                      "Public User Login page - clicked into the Send Activate Mail button";
                    redirectURL = "/public/SendActivateMail";
                    Status = "Redirected into Send Active Mail page";
                    Response = '---';
                    EventLog(dispatch, infoMessage, redirectURL, Response, Status);
                  }}
                >
                  {" "}
                  Resend Activation Mail
                </Link>
              </div>
              <p className="mb-20px pb-20px text-dark text-center mt-3">
                Don't have an account?{" "}
                <b>
                  {/* <Link to="/public/Register" className="link-style"> */}
                  <Link
                    to="/public/Register"
                    className="link-style"
                    onClick={() => {
                      infoMessage =
                        "Public User Login page - clicked into the new user signup button";
                      redirectURL = "/public/Register";
                      Status = "Redirected into new user registration page";
                      EventLog(dispatch, infoMessage, redirectURL, "---", Status);
                    }}
                  >
                    {" "}
                    Click here to Sign Up
                  </Link>
                </b>
              </p>
              <hr className="bg-gray-600 opacity-2" />
              <p className="text-center text-gray-600">
                &copy; Inmate Inbox All Right Reserved{" "}
                {new Date().getFullYear()}
              </p>
            </form>
          </div>
        </div>

        {loader}
      </div>

      <Link
        className="btn btn-icon btn-circle btn-theme btn-scroll-to-top"
        data-toggle="scroll-to-top"
      >
        <i className="fa fa-angle-up"></i>
      </Link>

      <ConfirmationModal
        show={isReactivateAccount}
        onHide={handlecancel}
        onConfirm={handleReactivate}
        title="Message"
        message="Your account is temporarily deactivated, you can reactivate your account now. Please click YES to activate and login to your account."
        closeButton={false}
      />

      {isModalOpen && (
        <PopupComponent
          isModalOpen={isModalOpen}
          inmateKioskInvite={inmateKioskInvite}
          onSignupClick={onSignupClick}
          onLoginClick={onLoginClick}
        />
      )}
      {isModalOpenAndroid && (
        <AndroidPopupComponent
          isModalOpenAndroid={isModalOpenAndroid}
          onLoginClick={onMobileLoginClick}
        />
      )}
      {isModalOpenApple && (
        <ApplePopupComponent
          isModalOpenApple={isModalOpenApple}
          onLoginClick={onMobileLoginClick}
        />
      )}
      <ConfirmationModal
        show={isInviteLinkModal}
        onHide={handlecancelInvite}
        onConfirm={handlecancelInvite}
        title="Message"
        message="Incorrect Invite Link"
        closeButton={false}
        onconfirmname={"Ok"}
        showCancelButton={false}
      />
    </div>
  );
}

export default React.memo(Login);
